import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'operatorTransformer'
})
export class OperatorTransformerPipe implements PipeTransform {
  transform(value: string): string {
    switch (value?.toLowerCase()) {
      case 'morethan':
        return '>';
      case 'lessthan':
        return '<';
      case 'equal':
        return '=';
      case 'morethanequal':
        return '≥';
      case 'lessthanequal':
        return '≤';
      case 'notequal':
        return '≠';
      default:
        return value;
    }
  }
}
